var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: _vm.drawerTitle,
        visible: _vm.drawerVisible,
        direction: "rtl",
        size: "80%",
        "append-to-body": "",
        "custom-class": "myDrawer",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "goods-visibility-check" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品ID" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入商品ID" },
                    model: {
                      value: _vm.searchForm.goods_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "goods_id", $$v)
                      },
                      expression: "searchForm.goods_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品可配送城市" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("商品可配送城市")]),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content:
                              "1、检索结果不包含第三方接口商品（如京东）；2、选择省份时，显示可配送此省份任意城市的商品；",
                            placement: "top",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.regionList,
                      "popper-class": "city-style",
                      props: {
                        checkStrictly: true,
                        emitPath: false,
                        label: "label",
                        value: "region_id",
                        children: "children",
                      },
                      clearable: "",
                      filterable: "",
                    },
                    model: {
                      value: _vm.searchForm.city_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "city_id", $$v)
                      },
                      expression: "searchForm.city_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查 询")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重 置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                border: "",
                data: _vm.dataList,
                "header-cell-style": {
                  background: "#F1F1F1",
                  color: "#333333",
                },
              },
              on: { "sort-change": _vm.sortChange },
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: { label: "", prop: "goods_name" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "goods-info" },
                            [
                              _c(
                                "el-image",
                                {
                                  staticClass: "goods-img",
                                  attrs: {
                                    src:
                                      scope.row.image_path +
                                      "?x-oss-process=image/auto-orient,1/interlace,1/resize,m_lfit,w_200/quality,q_90",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-slot",
                                      attrs: { slot: "placeholder" },
                                      slot: "placeholder",
                                    },
                                    [
                                      _vm._v(" 加载中"),
                                      _c("span", { staticClass: "dot" }, [
                                        _vm._v("..."),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "goods-detail" }, [
                                _c("div", { staticClass: "info__style" }, [
                                  _vm._v(" " + _vm._s(scope.row.goods_name)),
                                ]),
                                _c("div", { staticClass: "info-row" }, [
                                  _c("div", { staticClass: "cat-name" }, [
                                    _vm._v(_vm._s(scope.row.cat_name)),
                                  ]),
                                  _c("div", { staticClass: "jd-comment" }, [
                                    _vm._v(
                                      "京东评论数 " +
                                        _vm._s(scope.row.jd_comment_count)
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "info-row" }, [
                                  _c("span", [
                                    _vm._v(
                                      "ID：" +
                                        _vm._s(scope.row.goods_id) +
                                        " (" +
                                        _vm._s(scope.row.platform) +
                                        ")"
                                    ),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", [_vm._v("商品信息")]),
                    _vm.dataList.length > 0
                      ? _c(
                          "span",
                          {
                            class:
                              _vm.dataList[0].is_visible === 0
                                ? "visibility-tag visibility-tag--hidden"
                                : "visibility-tag visibility-tag--visible",
                            staticStyle: { "margin-left": "10px" },
                          },
                          [
                            _c("i", {
                              class:
                                _vm.dataList[0].is_visible === 0
                                  ? "el-icon-warning"
                                  : "el-icon-success",
                              staticStyle: { "margin-right": "0px" },
                            }),
                            _vm._v(
                              _vm._s(
                                _vm.dataList[0].is_visible === 0
                                  ? "商品不可见"
                                  : "商品可见"
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                2
              ),
              _c("el-table-column", {
                attrs: {
                  label: "排序",
                  prop: "sort_order",
                  sortable: "sort_order",
                  width: "90",
                  "sort-orders": ["descending", "ascending", null],
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("div", [_vm._v(_vm._s(scope.row.sort_order))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "起购/限购", width: "150px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.min_buy_number > 0
                          ? _c("div", { staticClass: "buy-row" }, [
                              _vm._v(
                                " 起购：" +
                                  _vm._s(scope.row.min_buy_number) +
                                  " (非默认) "
                              ),
                            ])
                          : _c("div", { staticClass: "buy-row" }, [
                              _vm._v(
                                " 起购：" +
                                  _vm._s(scope.row.default_min_buy_number) +
                                  " "
                              ),
                            ]),
                        scope.row.quota_number
                          ? _c("div", { staticClass: "quota-text" }, [
                              _vm._v(
                                " 限购：" +
                                  _vm._s(scope.row.nature_day) +
                                  "天" +
                                  _vm._s(scope.row.quota_number) +
                                  "个 "
                              ),
                            ])
                          : _c("div", [_vm._v("限购：-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "建议售价", prop: "shop_price", width: "90px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.shop_price))]),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: "京东价",
                    prop: "other_platform_price",
                    width: "90px",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("京东价")]),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "京东、天猫等主流电商的售价",
                            placement: "top",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: "京东到手价",
                    prop: "final_price",
                    width: "100px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.final_price || "-")),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("span", [_vm._v("京东到手价")]),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "使用各种优惠后实际到手的价格",
                            placement: "top",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { label: "是否特价", width: "90px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.is_promotion === "1" ? "是" : "否"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c(
                      "span",
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "light",
                              content:
                                "设为特价的商品，会忽略商城利润率条件强制展示",
                              placement: "top-start",
                            },
                          },
                          [_c("span", { staticClass: "el-icon-info img-icon" })]
                        ),
                        _c("span", [_vm._v("是否特价")]),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "是否锁定", width: "90px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.is_lock_goods == 1 ? "是" : "否")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.errorDataList.length > 0
            ? _c(
                "div",
                { staticClass: "error-list-section" },
                [
                  _c("h4", { staticClass: "error-list-title" }, [
                    _vm._v("该商品触发以下规则限制，请核对如有需要可调整规则"),
                  ]),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        border: "",
                        data: _vm.errorDataList,
                        "header-cell-style": {
                          background: "#F1F1F1",
                          color: "#333333",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "index", label: "序号", width: "60" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "分类", prop: "category" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "检查项", prop: "check_item" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "检查内容", prop: "check_content" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "检查结果", prop: "check_result" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "可见性检查", prop: "visibility" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.visibility == 1
                                            ? "success"
                                            : "danger",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.visibility == 1
                                              ? "满足"
                                              : "不满足"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2337433245
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }